import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row g-2" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "border rounded p-2 h-100 d-flex flex-column" }
const _hoisted_9 = { class: "mt-auto" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted text-center",
  style: {"font-size":"0.7rem"}
}
const _hoisted_11 = {
  key: 1,
  class: "d-grid"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "border rounded p-2 h-100 d-flex flex-column" }
const _hoisted_16 = { class: "mt-auto" }
const _hoisted_17 = {
  key: 0,
  class: "text-muted text-center",
  style: {"font-size":"0.7rem"}
}
const _hoisted_18 = { class: "d-grid" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fas fa-graduation-cap fa-fw me-1" }),
        _createTextVNode("Activar GTR Fly ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.basicActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input secondary",
                type: "checkbox",
                role: "switch",
                id: "enable-gtr-basic",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.enabled]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-muted small mb-2" }, [
        _createTextVNode(" Activa el paquete GTR Fly (Academia + Licencia de Distribuidor) y "),
        _createElementVNode("strong", null, "coloca"),
        _createTextVNode(" al usuario en la red. ")
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"text-muted text-uppercase text-center mb-2\" style=\"font-size:0.7rem;\"> Sin Volumen </div><ul class=\"list-unstyled small mb-2\"><li><i class=\"fas fa-xmark fa-fw text-danger me-1\"></i>Bono de Venta Directa </li><li><i class=\"fas fa-xmark fa-fw text-danger me-1\"></i>Binario</li><li><i class=\"fas fa-xmark fa-fw text-danger me-1\"></i>Rango</li></ul>", 2)),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.basicActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Ya cuenta con el básico activo. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-warning btn-sm",
                      disabled: !_ctx.enabled || _ctx.activating !== null,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activate('both')))
                    }, [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-check fa-fw me-1" }, null, -1)),
                      _cache[5] || (_cache[5] = _createTextVNode("Activar ", -1)),
                      (_ctx.activating === 'both')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_12)
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"text-muted text-uppercase text-center mb-2\" style=\"font-size:0.7rem;\"> Premio de Rifa </div><ul class=\"list-unstyled small mb-1\"><li><i class=\"fas fa-check fa-fw text-success me-1\"></i>Bono de Venta Directa </li><li><i class=\"fas fa-xmark fa-fw text-danger me-1\"></i>Binario</li><li><i class=\"fas fa-xmark fa-fw text-danger me-1\"></i>Rango</li></ul>", 2)),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.everActivated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " No disponible: el usuario ya ha estado activo. "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", {
                      class: "text-muted text-center mb-2",
                      style: {"font-size":"0.65rem"}
                    }, " Solo usuarios nuevos ", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-success btn-sm",
                        disabled: !_ctx.enabled || _ctx.activating !== null,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activate('prize')))
                      }, [
                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-check fa-fw me-1" }, null, -1)),
                        _cache[8] || (_cache[8] = _createTextVNode("Activar ", -1)),
                        (_ctx.activating === 'prize')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_19)
                    ])
                  ], 64))
            ])
          ])
        ])
      ])
    ])
  ]))
}